import { useMutation } from "react-query";
import { loggedInApiCall } from "src/api/axiosClient/userApi";

const baseUrl = "/api/data_list_version_value_overrides" as const;

export const useDeleteDataListValueOverride = () => {
    return useMutation({
        mutationFn: async (id: number) => {
            return await loggedInApiCall.delete(`${baseUrl}/${id}`);
        },
    });
};
